export const FILTERS = "filters";
export const ANALYTICS = "analytics";
export const RELATED_SEARCHES = "related";
